module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageHome.elements) ? _c('div', {
    staticClass: "landing-home"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "DIWM_contact-form container-fluid col-xs-12",
    attrs: {
      "id": "contact-form"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bg-contact"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSchedule a Report Briefing\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "id": "contactForm",
      "data-vv-scope": "contactForm",
      "action": "https://crm.zoho.com/crm/WebToLeadForm",
      "name": "WebToLeads3285587000000345044",
      "method": "POST",
      "accept-charset": "UTF-8"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('contactForm')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "captcha_settings",
      "value": "{\"keyname\":\"Captcha\",\"fallback\":\"true\",\"orgId\":\"00D6A0000038T85\",\"ts\":\"\"}"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "oid",
      "value": "00D6A0000038T85"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "retURL",
      "value": "http://"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Campaign_ID",
      "value": "7013u0000007aSHAAY"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lead_source",
      "value": "Website"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.first_name')
    }
  }, [(_vm.contactForm.first_name === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.first_name),
      expression: "contactForm.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "first_name",
      "maxlength": "40",
      "name": "first_name",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.contactForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.First Name')),
      expression: "errors.has('contactForm.First Name')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.first_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.last_name')
    }
  }, [(_vm.contactForm.last_name === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.last_name),
      expression: "contactForm.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "last_name",
      "maxlength": "80",
      "name": "last_name",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.contactForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.Last Name')),
      expression: "errors.has('contactForm.Last Name')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.last_name')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.company')
    }
  }, [(_vm.contactForm.company === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.company),
      expression: "contactForm.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company",
      "maxlength": "100",
      "name": "company",
      "placeholder": "Company"
    },
    domProps: {
      "value": (_vm.contactForm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "company", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.Company')),
      expression: "errors.has('contactForm.Company')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.Company')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.email')
    }
  }, [(_vm.contactForm.email === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.email),
      expression: "contactForm.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "maxlength": "100",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.contactForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.Email')),
      expression: "errors.has('contactForm.Email')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.Email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.phone')
    }
  }, [(_vm.contactForm.phone === '') ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.phone),
      expression: "contactForm.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "maxlength": "100",
      "name": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.contactForm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.phone')),
      expression: "errors.has('contactForm.phone')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.phone')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      error: _vm.errors.has('contactForm.url')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactForm.url),
      expression: "contactForm.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "url",
      "maxlength": "100",
      "name": "url",
      "placeholder": "Website"
    },
    domProps: {
      "value": (_vm.contactForm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactForm, "url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactForm.url')),
      expression: "errors.has('contactForm.url')"
    }],
    staticClass: "message-error"
  }, [_vm._v(_vm._s(_vm.errors.first('contactForm.url')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6 col-md-12 col-lg-6"
  }, [_c('vue-recaptcha', {
    staticClass: "captcha",
    attrs: {
      "sitekey": "6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"
    },
    on: {
      "verify": _vm.markRecaptchaAsVerifiedContact
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "captcha-error"
  }, [_c('p', {
    staticClass: "text-small"
  }, [_vm._v(_vm._s(_vm.contactForm.pleaseTickRecaptchaMessage))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6 col-md-12 col-lg-6 text-right",
    class: {
      error: _vm.errors.has('contactForm.Email')
    }
  }, [_c('button', {
    staticClass: "btn_orange gtm_buttonCX2_contactformsubmit",
    attrs: {
      "type": "submit",
      "tag": "button"
    }
  }, [_vm._v("Schedule the presentation")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contactForm.formSubmitted) ? _c('div', {
    class: [_vm.contactForm.formSubmitted ? 'thank-message fadeIn' : '']
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "row"
  }, [_vm._m(3)])]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "DIWM_section-block DIWM_doitwithme container-fluid col-xs-12",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t\tHere are just a few key findings from the research that may offer insight into connecting with Millennials:\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "row item"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3 col-lg-offset-1 image"
  }, [_c('img', {
    attrs: {
      "src": "/dist/mti16284-1_DIWM1_V04LO_20190906.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM1_V04LO_20190906.pdf')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-7 infomation"
  }, [_c('h3', [_vm._v("Millennials: The most misunderstood demographic in the DIY space.")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tThe Millennial DIY story is a story of contradictions. Millennials actually have experience working on home projects with their parents. They actually shop online and in store. They don’t know everything, but they aren’t afraid to ask friends, family, YouTubers and in-store associates for advice. That said, fewer Millennial homeowners hire professionals (just 13%) because they think they’ll get the runaround or get  hustled.\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn_orange",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM1_V04LO_20190906.pdf')
      }
    }
  }, [_vm._v("Download Infographic")])])]), _vm._v(" "), _c('div', {
    staticClass: "row item"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3 col-lg-offset-1 image"
  }, [_c('img', {
    attrs: {
      "src": "/dist/mti16284-1_DIWM3_V04LO_20190906.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM3_V04LO_20190906.pdf')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-7 infomation"
  }, [_c('h3', [_vm._v("Millennials do home improvement, but they don’t do it alone.")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tMillennials spend more time taking trips to stores when working on DIY projects than older generations do. One in four (23%) Millennials say that, sometimes, they spend more time making trips to the store for a home improvement project than they do working on the project itself! (vs. 12% of Gen Xers and 10% of Boomers)\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn_orange",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM3_V04LO_20190906.pdf')
      }
    }
  }, [_vm._v("Download Infographic")])])]), _vm._v(" "), _c('div', {
    staticClass: "row item"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3 col-lg-offset-1 image"
  }, [_c('img', {
    attrs: {
      "src": "/dist/mti16284-1_DIWM4_V04LO_20190906.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM4_V04LO_20190906.pdf')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-7 infomation"
  }, [_c('h3', [_vm._v("Millennials are more confident, but less prepared.")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tMillennials are brave when it comes to home improvement. In fact, 56% of them said they did their first home project DIY. (That said, 52% said they didn’t have all the tools supplies and materials they needed before they started.)\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn_orange",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM4_V04LO_20190906.pdf')
      }
    }
  }, [_vm._v("Download Infographic")])])]), _vm._v(" "), _c('div', {
    staticClass: "row item"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3 col-lg-offset-1 image"
  }, [_c('img', {
    attrs: {
      "src": "/dist/mti16284-1_DIWM2_V04LO_20190906.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM2_V04LO_20190906.pdf')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-7 infomation"
  }, [_c('h3', [_vm._v("Millennials do more home improvement than their parents.")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tJust when you thought it was all snack foods and video games, it turns out Millennials love their home improvement. They take more pride in their home improvement than just about anything else they do. They’ll even call in sick to work on a DIY project. Who knew?\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn_orange",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.savePDFfile('mti16284-1_DIWM2_V04LO_20190906.pdf')
      }
    }
  }, [_vm._v("Download Infographic")])])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "DIWM_section-block DIWM_about container-fluid col-xs-12",
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t\tAbout Marcus Thomas\n\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tMarcus Thomas is a 221-person full-service agency based in Cleveland, Ohio. The agency has deep understanding of the home and garden segment and its hardware, big box and ecommerce channel partners.\n\t\t\t\t")]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('Footer')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('h1', [_vm._v("\n\t\t\t\t\t\t\t\t\tDIY"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\tMarketers:\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "subheadline"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tWe all know Millennials are different. We’ll tell you what you don’t know.\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\tWhen you ask 2000+ homeowners (including Millennials) about their habits relative to DIY, their answers can be quite revealing.\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\tThe largest segment of homeowners ever, Millennials are just entering homebuying age, and Marcus Thomas Chief Client Officer Mark Bachmann believes this 2019 study indicates that marketers need to "), _c('strong', [_vm._v("\"adjust preconceived notions about this segment.\"")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\tTo schedule a 30-minute briefing on the full research report, just complete the form or contact Mark Bachmann, Chief Client Officer, via email or call 216.514.4544.\n\t\t\t\t\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "text-small"
  }, [_vm._v("* Required fields.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Ok, you’ve taken the first step. We’ll get back to you within one business day.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xm-12 brand-container"
  }, [_c('img', {
    attrs: {
      "alt": "Behr",
      "src": "/dist/behr.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Behr",
      "src": "/dist/kraftmaid.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Behr",
      "src": "/dist/troy-bilt.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Behr",
      "src": "/dist/kichler.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Behr",
      "src": "/dist/moen.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc8acd0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/DoItWithMe.vue
// module id = 1505
// module chunks = 0